/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ForceNativeScrollDirective as ɵa} from './lib/perfect-scrollbar-force-native-scroll.directive';